import { render, staticRenderFns } from "./ReportingMainSectionSidebar.vue?vue&type=template&id=22f08449&scoped=true&"
import script from "./ReportingMainSectionSidebar.vue?vue&type=script&lang=js&"
export * from "./ReportingMainSectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ReportingMainSectionSidebar.vue?vue&type=style&index=0&id=22f08449&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f08449",
  null
  
)

export default component.exports